import { useCallback, useState } from 'react';

import useDelayedClose from 'Hooks/useDelayedClose';

const useModalState = shouldUseDelayedClose => {
	const [isOpen, setIsOpen] = useState(false);
	const isClosed = useDelayedClose(isOpen, !shouldUseDelayedClose);

	const closeModal = useCallback(() => {
		setIsOpen(false);
	}, []);
	const openModal = useCallback(() => {
		setIsOpen(true);
	}, []);

	return { closeModal, openModal, isOpen, ...(shouldUseDelayedClose && { isClosed }) };
};

export default useModalState;
